import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';

import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuDirective, NzMenuModule, NzSubMenuComponent } from 'ng-zorro-antd/menu';
import { RouterLink, RouterModule } from '@angular/router';
import { NzTooltipDirective, NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzIconDirective, NzIconModule } from 'ng-zorro-antd/icon';
import { Page404Component } from './components/page404/page404.component';
import { SidebarMenuComponent } from './components/sidebar-menu/sidebar-menu.component';
import { SimpleLayoutComponent } from './simple-layout/simple-layout.component';
import { SidebarLayoutComponent } from './sidebar-layout/sidebar-layout.component';
import { ModalConfirmCodeModule } from '../modules/modal-confirm-code';
import { PrintLayoutComponent } from './print-layout/print-layout.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NzLayoutModule,
    NzMenuModule,
    NzTooltipDirective,
    NzIconDirective,
    RouterLink,
    NzSubMenuComponent,
    AsyncPipe,
    NzMenuDirective,
    NzTooltipModule,
    NzBreadCrumbModule,
    NzIconModule,
    ModalConfirmCodeModule,
  ],
  exports: [
    SimpleLayoutComponent,
    SidebarLayoutComponent,
    Page404Component,
    SidebarMenuComponent,
    PrintLayoutComponent,
  ],
  declarations: [
    SimpleLayoutComponent,
    SidebarLayoutComponent,
    Page404Component,
    SidebarMenuComponent,
    PrintLayoutComponent,
  ],
})
export class LayoutModule {}
